export default __webpack_public_path__ + "static/media/tokentrader.459a3957.png";